<template>
  <div class="container">
    <content-header :data="[{text:'品牌一览', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <div class="search-entry">
          <el-button type="primary" icon="plus" @click="initNewHandle">添加</el-button>
        </div>
        <div class="search-entry">
            <el-input
              placeholder="请输入查询关键字"
              v-model="keywords">
            </el-input>
        </div>
        <div class="search-btn">
          <el-button type="primary" @click="searchHandle">查询</el-button>
        </div>
      </div>
      <!-- 列表区域 -->
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            prop="name"
            label="品牌名称"
            width="200">
          </el-table-column>
          <el-table-column
            label="图片">
            <template slot-scope="scope">
            <img style="width:102px;height:36px":src="domainPic + scope.row.logo" v-if="scope.row.logo"/>
            </template>
          </el-table-column>
          <el-table-column
            prop="description"
            label="描述">
          </el-table-column>
          <!--el-table-column
            prop="modifier_name"
            label="操作人"
            width="100">
          </el-table-column>
          <el-table-column
            prop="modified"
            label="操作时间"
            width="180"-->
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="200">
            <template slot-scope="scope">
              <el-button @click="editHandle(scope)" type="text" size="small" >修改</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small" >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="total > curSize">
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="curPageChange"
            :current-page="curPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="curSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
      <!-- 新建品牌弹出区域 -->
      <div class="new-wrap">
        <el-dialog :title="curObj.row.id ? '修改品牌' : '添加品牌'" :visible.sync="isNewShow">
          <el-form :model="newObj" :rules="newObjRules" ref="newObjForm" label-position="right" label-width="0px">
            <el-form-item prop="name" label="品牌名称" :label-width="formLabelWidth">
              <el-input name="name" v-model="newObj.name" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="logo" label="LOGO" :label-width="formLabelWidth">
              <el-upload
                class="avatar-uploader"
                action="//upload-z2.qiniup.com"
                :data="uploadForm"
                :show-file-list="false"
                :on-success="uploadPhotoSuccess"
                :before-upload="beforePhotoUpload"
                :on-error="uploadError">
                <img v-if="newObj.logo" :src="domainPic + newObj.logo" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item prop="description" label="描述" :label-width="formLabelWidth">
              <el-input type="textarea" v-model="newObj.description" auto-complete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelHandle">取 消</el-button>
            <el-button type="primary" @click="confirmHandle">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import constants from 'config/constants'
  import date from 'utils/date'
  import BrandModel from 'models/brand'
  import CommonModel from 'models/common'

  export default {
    data () {
      return {
        domainPic: constants.basic.domain_pic,
        keywords: '',
        tableData: [],
        isNewShow: false,
        newObj: {
          name: '',
          logo: '',
          description: ''
        },
        formLabelWidth: '80px',
        newObjRules: {
          name: [{ required: true, message: '请输入品牌名称', trigger: 'blur' }]
        },
        curPage: 1,
        curSize: 10,
        total: 0,
        curObj: {
          row: {}
        },
        isEdit: false,
        editObj: {},
        editIndex: null,
        //
        uploadForm: {key: '', token: ''},
        qiniuHost: '',
      }
    },
    created () {
      this.getObjList()
    },
    methods: {
      //
      uploadRemove (file, fileList) {
        console.log(file)
      },
      uploadError (err, file, fileList) {
        console.log(err)
      },
      uploadExceed (files, fileList) {
        console.log(files.length)
      },
      uploadPhotoSuccess (response, file, fileList) {
        // console.log(response)
        this.newObj.logo = response.key
      },
      beforePhotoUpload (file) {
        const isPic = (file.type === 'image/jpeg' || file.type === 'image/png')
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isPic) {
          this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
          return false
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
          return false
        }
        //
        if (!this.uploadForm.token) {
          return CommonModel.getQiniuUptoken().then(res => {
            this.qiniuHost = res.qiniuHost
            this.uploadForm.token = res.uptoken
            let curr = date(new Date().getTime(), 'yyyyMMdd')
            let prefix = 'brand'
            let suffix = file.name
            this.uploadForm.key = encodeURI(`${prefix}/${curr}_${suffix}`)
            console.log(this.uploadForm)
          })
        } else {
          let curr = date(new Date().getTime(), 'yyyyMMdd')
          let prefix = 'brand'
          let suffix = file.name
          this.uploadForm.key = encodeURI(`${curr}/${prefix}_${suffix}`)
          console.log(this.uploadForm)
        }
        return true
      },
      //
      pageSizeChange (size) {
        this.curSize = size
        this.getObjList()
      },
      curPageChange (page) {
        this.curPage = page
        this.getObjList()
      },
      getObjList (opts) {
        const _opts = {
          curPage: this.curPage,
          pageSize: this.curSize
        }
        // 合并参数
        if (typeof opts === 'object') Object.assign(_opts, opts)
        //
        BrandModel.find(_opts).then(res => {
          this.tableData = res.rows
          this.total = res.total
        })
      },
      cancelHandle () {
        this.$refs.newObjForm.resetFields()
        this.isNewShow = false
      },
      editHandle (data) {
        this.curObj = data
        this.newObj = {
          name: data.row.name,
          logo: data.row.logo,
          description: data.row.description
        }
        this.isNewShow = true
        this.isEdit = true
        this.editObj = data.row
        this.editIndex = data.$index
      },
      deleteHandle (item) {
        this.$confirm('确认删除 ' + item.row.name + '?')
          .then(_ => {
            BrandModel.delete({
              id: item.row.id,
            }).then(() => {
              this.getObjList()
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(_ => {
              this.$message({ message: '删除失败', type: 'error' })
            })
          })
          .catch(_ => {})
      },
      newObjHandle () {
        const opts = {
          name: this.newObj.name,
          logo: this.newObj.logo,
          description: this.newObj.description
        }
        if (this.isEdit) {
          opts.id = this.editObj.id
          // 更新品牌信息
          BrandModel.update(opts).then(() => {
            this.getObjList()
            this.successHandle('更新成功')
          }).catch(err => {
            this.$message({ message: err.message, type: 'error' })
          })
          return
        }
        // 创建新品牌
        BrandModel.create(opts).then(res => {
          this.getObjList()
          this.successHandle('添加成功')
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      successHandle (msg) {
        this.isNewShow = false
        this.$message({ message: msg, type: 'success' })
      },
      confirmHandle () {
        this.$refs.newObjForm.validate(valid => {
          if (!valid) return
          this.newObjHandle()
        })
      },
      initNewHandle () {
        this.curObj = { row: {} }
        this.newObj = {
          name: '',
          logo: '',
          description: ''
        }
        this.isNewShow = true
        this.isEdit = false
      },
      searchHandle () {
        this.getObjList({'keywords': this.keywords})
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
      .search-entry
        display: inline-block
        vertical-align: top
        margin-right: 20px
        span
          display: inline-block
          vertical-align: top
          line-height: 36px
        .entry-box
          display: inline-block
          vertical-align: top
          width: 140px
          &.username
            width: 140px
      .search-btn
        display: inline-block
        vertical-align: top
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
      .pagination
        margin-top: 10px
    .new-wrap
      .el-input
        width: 300px
      .form-title
        padding-top: 10px
        padding-bottom: 10px
        font-size: 12px
        color: #aaa
      .check-title
        text-align: right
        display: inline-block
        vertical-align: middle
        width: 90px
        font-size: 14px
        color: #48576a
        line-height: 1
        padding: 11px 12px 11px 0
        box-sizing: border-box
      .avatar-uploader
          border: 1px dashed #d9d9d9
          border-radius: 6px
          cursor: pointer
          position: relative
          overflow: hidden
          width: 206px
          &:hover
            border-color: #409EFF
          .avatar-uploader-icon
            font-size: 28px
            color: #8c939d
            width: 204px
            height: 72px
            line-height: 72px
            text-align: center
          .avatar
            width: 204px
            height: 72px
            display: block
</style>



// WEBPACK FOOTER //
// src/views/Brand.vue